import React from "react"
import { Link } from "react-router-dom"
import ProductLoader from "./ProductLoader"
import {
  formatNumber,
  substring
} from "../../normalizer"

const PostProduct = ({ colors, product, ...campaignProduct }) => {
  const { points, percentage } = campaignProduct
  const limitedName = substring(product.name, 35, "...")
  const currencyLabel = localStorage.getItem("currency") || "pts"
  
  return (
    <div style={{borderColor: `${colors.borderColor}`}} className="gl-product__container gl-product__container--post bg-default">
      <p className="gl-product__title gl-product__title--post text-color">
        {limitedName}
      </p>
      <Link to={`/catalog/product/${campaignProduct.id}`}>
        <img
          src={product.main_image.url}
          alt={product.name}
          className="gl-product__image gl-product__image--post"
        />
      </Link>
      <div style={{color: colors.textColor, backgroundColor: colors.backgroundColor}} 
           className="gl-product__action-container gl-product__action-container--post">
        <div className="gl-product__points-container">
          <span className="gl-product__points-value gl-product__points-value--post">
            {formatNumber(points)}
          </span>
          <span className="gl-product__points-label gl-product__points-label--post">
            {currencyLabel}
          </span>
          { percentage !== undefined &&
            <div className="gl-product__loader-container">
              <ProductLoader progress={percentage} />
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default PostProduct
